import React, {useEffect, useState} from 'react';
import {Box, Button, FormControlLabel, Modal, Radio, RadioGroup, Typography} from "@mui/material";
import {PopupHeader} from "../../com/popupHeader/popupHeader";
import {ReactComponent as WarningIconWithCircle} from "../../../assets/big_warning_with_circle_icon.svg";
import {savePagePromosAndItemsData} from "../../../store/actionCreators/flippingFlyerActionCreators";
import {useDispatch} from "react-redux";

interface Props {
    flyerId: number;
    file: File | null;
    lang: string | undefined;
    isOpen: boolean;
    onClose: VoidFunction;
}

export const UploadPromosItemsExcelOptionsPopup: React.FC<Props> = ({
                                                                        isOpen,
                                                                        flyerId = 0,
                                                                        file = null,
                                                                        lang= "",
                                                                        onClose
                                                                    }) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState<string>("1");

    useEffect(() => {
        return () => {
            setValue("1");
        };
    }, []);


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setValue(value);
    }

    const handleImport = () => {
        if(file){
            dispatch(savePagePromosAndItemsData(flyerId, file, lang, value));
            onClose();
        }
    }

    return (
        <Modal open={isOpen} disableScrollLock={true}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: `30vw`,
                    minWidth: `420px`,
                    maxWidth: `90vw`,
                    backgroundColor: `#ffffff`,
                    display: "flex",
                    flexFlow: "column",
                    maxHeight: `90vh`,
                }}
            >
                <PopupHeader onClose={onClose} headerCaption={"Upload Promos/Items Excel File"} jc={'start'}/>
                <Box
                    pt={"24px"}
                    px={"24px"}
                    sx={{
                        display: "flex",
                        flexFlow: "column",
                        rowGap: "20px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            columnGap: "20px",
                            alignItems: "center"
                        }}
                    >
                        <WarningIconWithCircle/>
                        <Typography
                            fontSize={`14px`}
                            fontWeight={`700`}
                        >
                            Note
                        </Typography>
                    </Box>
                    <Typography>
                        In case of duplicate items with identical Item Codes in the import file what would do you like to do:
                    </Typography>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={value}
                        name="radio-buttons-flyer-jpgs"
                        onChange={handleChange}
                    >
                        <FormControlLabel sx={{marginBottom: "0"}} value="1" control={<Radio />} label="Keep the first item and ignore the subsequent same coded item(s)" />
                        <FormControlLabel sx={{marginBottom: "0"}} value="2" control={<Radio />} label="Last item to overwrite previous same coded item(s)" />
                        <FormControlLabel sx={{marginBottom: "0"}} value="3" control={<Radio />} label="Do not upload any duplicate items. List them, I will fix them and reupload" />
                    </RadioGroup>
                </Box>
                <Box
                    p={"24px"}
                    sx={{
                        display: "flex",
                        columnGap: "20px"
                    }}
                >
                    <Button
                        onClick={handleImport}
                        sx={{
                            width: `100%`,
                            color: `initial`,
                            background: `#014780`,
                            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                            height: `40px`,
                            borderRadius: `0`,
                            margin: "0",
                            '&:hover': {
                                background: `#014780`,
                                opacity: `0.7`
                            },
                            '&:disabled': {
                                opacity: `0.5`
                            }
                        }}
                    >
                        <Typography color={"#ffffff"}>
                            Import
                        </Typography>
                    </Button>
                    <Button
                        onClick={onClose}
                        sx={{
                            width: `100%`,
                            color: `initial`,
                            background: `#FFFFFF`,
                            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                            height: `40px`,
                            borderRadius: `0`,
                            border: "1px solid #014780",
                            margin: "0",
                            '&:hover': {
                                background: `#014780`,
                                opacity: `0.7`,
                                "& > .MuiTypography-root": {
                                    color: "#FFFFFF"
                                }
                            },
                            '&:disabled': {
                                opacity: `0.5`
                            }
                        }}
                    >
                        <Typography color={"#014780"}>
                            Cancel
                        </Typography>
                    </Button>
                </Box>
            </Box>

        </Modal>

    )
}